var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page h-screen flex w-full vx-row no-gutter items-center justify-center bg-img",attrs:{"id":"page-login"}},[_c('div',{staticClass:"vx-col xs:w-1 sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3"},[_c('vx-card',{staticStyle:{"background-color":"#fff"}},[_c('LoginForm')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }